import { useExtendedAccountsFilters } from '@/ui/features/contact-management/AccountsPanel/hooks';
import { useAccountFilterConfig } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountsFilterConfig';
import { useDefaultAdvancedSearchItems } from '@juvare/contact-management/ui/features/accounts/hooks/useDefaultAdvancedSearchItems';
import { AdvancedSearchItem } from '@juvare/platform-sdk-react/ui/features/advanced-search';
import { useTranslation } from 'react-i18next';

export function useBackgroundCheckTableFilterConfig(requireOrgRoleInStatusFilter: boolean) {
    const { extendFilters } = useExtendedAccountsFilters();
    const { t } = useTranslation();
    const defaultAdvancedSearchItems: AdvancedSearchItem[] = useDefaultAdvancedSearchItems();

    return useAccountFilterConfig({
        requireOrgRoleInStatusFilter,
        advancedSearchItems: defaultAdvancedSearchItems,
        extendFilters: (builder) => {
            extendFilters(builder, { addPrimaryBackgroundCheckStatusQuickFilter: true });
            builder.quickDateRangeFilter({
                dataPath: 'primaryBackgroundUpdatedAt',
                label: t('accountsFilters.backgroundCheck.lastUpdate'),
                sx: { maxWidth: { xs: 1, sm: 280 }, width: 1 },
            });
        },
    });
}
